<script setup lang="ts">
import { Button } from '@/shared/ui/Button'

import { useTelegramAccountActions } from '../model/useTelegramAccountActions'

defineProps<{
  connected: boolean
}>()

const { isBusy, connect, disconnectBot } = useTelegramAccountActions()
</script>

<template>
  <Button
    v-if="connected"
    type="danger"
    plain
    :loading="isBusy"
    @click="disconnectBot"
  >
    Disconnect Telegram
  </Button>

  <Button v-else type="primary" :loading="isBusy" @click="connect">
    Connect Telegram
  </Button>
</template>
